import { render, staticRenderFns } from "./FieldDesignerPanel.vue?vue&type=template&id=21452792&scoped=true"
import script from "./FieldDesignerPanel.vue?vue&type=script&lang=js"
export * from "./FieldDesignerPanel.vue?vue&type=script&lang=js"
import style0 from "./FieldDesignerPanel.vue?vue&type=style&index=0&id=21452792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21452792",
  null
  
)

export default component.exports